export default __webpack_public_path__ + "static/media/instagram.d034a7f8.svg";